import Alpine from 'alpinejs';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

window.Alpine = Alpine;
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

Alpine.data('portfolioApp', () => ({
    lightboxImage: '',
    lightboxTitle: '',
    menuOpen: false,
    scrolled: false,
    openImage(image, title) {
        this.lightboxImage = image;
        this.lightboxTitle = title;
        document.body.classList.add('overflow-hidden');
    },
    closeImage() {
        this.lightboxImage = '';
        this.lightboxTitle = '';
        document.body.classList.remove('overflow-hidden');
    },
    init() {
        const update = () => { this.scrolled = window.scrollY > 24; };
        update();
        window.addEventListener('scroll', update, { passive: true });
    },
}));

Alpine.data('adminDashboard', () => ({
    activeSection: 'ringkasan',
    projectModal: false,
    sidebarOpen: false,
    toast: '',
    toastTimer: null,
    showToast(message) {
        this.toast = message;
        clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => { this.toast = ''; }, 2800);
    },
}));

document.addEventListener('DOMContentLoaded', () => {
    const lightbox = document.querySelector('#project-lightbox');
    const lightboxImage = document.querySelector('#project-lightbox-image');
    const lightboxTitle = document.querySelector('#project-lightbox-title');

    const closeLightbox = () => {
        if (!lightbox) return;
        lightbox.classList.add('hidden');
        lightbox.classList.remove('grid');
        document.body.classList.remove('overflow-hidden');
    };

    document.querySelectorAll('[data-project-lightbox]').forEach((button) => {
        button.addEventListener('click', () => {
            if (!lightbox || !lightboxImage || !lightboxTitle) return;
            lightboxImage.src = button.dataset.image || '';
            lightboxImage.alt = `Tampilan ${button.dataset.title || 'proyek'}`;
            lightboxTitle.textContent = button.dataset.title || '';
            lightbox.classList.remove('hidden');
            lightbox.classList.add('grid');
            document.body.classList.add('overflow-hidden');
        });
    });

    document.querySelector('[data-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeLightbox();
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const timeline = gsap.timeline({ defaults: { ease: 'power4.out' } });
        timeline.from('[data-hero-line]', { yPercent: 110, duration: 1.15, stagger: 0.1 })
            .from('[data-hero]', { autoAlpha: 0, y: 20, duration: 0.7, stagger: 0.1 }, '-=.55');

        gsap.to('.orb', { yPercent: 35, ease: 'none', scrollTrigger: { trigger: '#home', start: 'top top', end: 'bottom top', scrub: true } });
    }

    gsap.utils.toArray('[data-gsap="fade-up"]').forEach((element) => {
        gsap.from(element, {
            autoAlpha: 0,
            duration: 0.8,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: element,
                start: 'top 85%',
                once: true,
            },
            y: 32,
        });
    });
});

// Register native interactions first so they remain available if an Alpine component fails.
Alpine.start();
